// atom/userGroupState.js 파일

import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const userGroupState = atom({
  key: "userGroupState",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
